// src/enums/common.ts
var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["Development"] = "development";
  Environment2["Test"] = "test";
  Environment2["Production"] = "production";
  return Environment2;
})(Environment || {});
var HealthStatus = /* @__PURE__ */ ((HealthStatus2) => {
  HealthStatus2["Ok"] = "ok";
  HealthStatus2["Degraded"] = "degraded";
  HealthStatus2["Down"] = "down";
  return HealthStatus2;
})(HealthStatus || {});
var RequestSource = /* @__PURE__ */ ((RequestSource2) => {
  RequestSource2["Body"] = "body";
  RequestSource2["Query"] = "query";
  RequestSource2["Cookies"] = "cookies";
  return RequestSource2;
})(RequestSource || {});
var SyncStatus = /* @__PURE__ */ ((SyncStatus2) => {
  SyncStatus2["PENDING"] = "PENDING";
  SyncStatus2["SYNC"] = "SYNC";
  SyncStatus2["SYNC_ADD"] = "SYNC_ADD";
  return SyncStatus2;
})(SyncStatus || {});
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["Asc"] = "asc";
  SortOrder2["Desc"] = "desc";
  return SortOrder2;
})(SortOrder || {});

// src/enums/account.ts
var AccountSide = /* @__PURE__ */ ((AccountSide2) => {
  AccountSide2["CHAN"] = "CHAN";
  AccountSide2["LE"] = "LE";
  return AccountSide2;
})(AccountSide || {});
var HitAccountType = /* @__PURE__ */ ((HitAccountType2) => {
  HitAccountType2["USER"] = "USER";
  return HitAccountType2;
})(HitAccountType || {});
var AccountRunStatus = /* @__PURE__ */ ((AccountRunStatus2) => {
  AccountRunStatus2["STOPPED"] = "STOPPED";
  AccountRunStatus2["RUNNING"] = "RUNNING";
  return AccountRunStatus2;
})(AccountRunStatus || {});

// src/enums/game.ts
var GameType = /* @__PURE__ */ ((GameType2) => {
  GameType2["TX"] = "TX";
  GameType2["XD"] = "XD";
  GameType2["XDMD5"] = "XDMD5";
  GameType2["BAUCUA"] = "BAUCUA";
  return GameType2;
})(GameType || {});
var GameBetKey = /* @__PURE__ */ ((GameBetKey2) => {
  GameBetKey2["TAI"] = "TAI";
  GameBetKey2["XIU"] = "XIU";
  GameBetKey2["CHAN"] = "CHAN";
  GameBetKey2["LE"] = "LE";
  GameBetKey2["_4T"] = "4T";
  GameBetKey2["_4D"] = "4D";
  GameBetKey2["_3T1D"] = "3T1D";
  GameBetKey2["_3D1T"] = "3D1T";
  GameBetKey2["_2D2T"] = "2D2T";
  GameBetKey2["BAU"] = "BAU";
  GameBetKey2["CUA"] = "CUA";
  GameBetKey2["CA"] = "CA";
  GameBetKey2["TOM"] = "TOM";
  GameBetKey2["GA"] = "GA";
  GameBetKey2["NAI"] = "NAI";
  return GameBetKey2;
})(GameBetKey || {});
var XOC_DIA_KEYS = [
  "CHAN" /* CHAN */,
  "LE" /* LE */,
  "4T" /* _4T */,
  "4D" /* _4D */,
  "3T1D" /* _3T1D */,
  "3D1T" /* _3D1T */,
  "2D2T" /* _2D2T */
];
var BAU_CUA_KEYS = [
  "BAU" /* BAU */,
  "CUA" /* CUA */,
  "CA" /* CA */,
  "TOM" /* TOM */,
  "GA" /* GA */,
  "NAI" /* NAI */
];
var BET_KEYS_BY_GAME = {
  ["TX" /* TX */]: ["TAI" /* TAI */, "XIU" /* XIU */],
  ["XD" /* XD */]: XOC_DIA_KEYS,
  ["XDMD5" /* XDMD5 */]: XOC_DIA_KEYS,
  ["BAUCUA" /* BAUCUA */]: BAU_CUA_KEYS
};
function isBetKeyOfGame(gameType, key) {
  return BET_KEYS_BY_GAME[gameType].includes(key);
}
var BET_LIMITS_BY_GAME = {
  ["TX" /* TX */]: { min: 1e3, step: 1e3 },
  ["XD" /* XD */]: { min: 1e3, step: 1e3 },
  ["XDMD5" /* XDMD5 */]: { min: 100, step: 100 },
  // Khớp BAUCUA_MIN_BET/BAUCUA_BET_STEP của game-sdk: chip nhỏ nhất của phòng là 500.
  ["BAUCUA" /* BAUCUA */]: { min: 500, step: 500 }
};
function isValidBetAmount(gameType, amount) {
  const { min, step } = BET_LIMITS_BY_GAME[gameType];
  return Number.isInteger(amount) && amount >= min && amount % step === 0;
}

// src/enums/role.ts
var RoleType = /* @__PURE__ */ ((RoleType2) => {
  RoleType2["ADMIN"] = "ADMIN";
  RoleType2["USER"] = "USER";
  return RoleType2;
})(RoleType || {});

// src/enums/user.ts
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2["ACTIVE"] = "ACTIVE";
  UserStatus2["INACTIVE"] = "INACTIVE";
  return UserStatus2;
})(UserStatus || {});

// src/enums/betlog.ts
var BetLogServiceName = /* @__PURE__ */ ((BetLogServiceName2) => {
  BetLogServiceName2["TX"] = "T\xE0i X\u1EC9u Live";
  BetLogServiceName2["XD"] = "X\xF3c \u0110\u0129a Live";
  BetLogServiceName2["XDMD5"] = "X\xF3c \u0110\u0129a MD5";
  BetLogServiceName2["BAUCUA"] = "B\u1EA7u Cua";
  return BetLogServiceName2;
})(BetLogServiceName || {});
export {
  AccountRunStatus,
  AccountSide,
  BET_KEYS_BY_GAME,
  BET_LIMITS_BY_GAME,
  BetLogServiceName,
  Environment,
  GameBetKey,
  GameType,
  HealthStatus,
  HitAccountType,
  RequestSource,
  RoleType,
  SortOrder,
  SyncStatus,
  UserStatus,
  isBetKeyOfGame,
  isValidBetAmount
};
//# sourceMappingURL=index.js.map